import { useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { getUserWallet } from 'services/apiUserCreditManagement'

const useGetWalletData = () => {
  
  const queryClient = useQueryClient()

  const {isPending,isSuccess,isError,isFetching,refetch,error,data} = useQuery({
    queryKey:['userWallet'],
    queryFn: ()=> getUserWallet(),
    staleTime: 2 * 60 * 60 * 1000,

  })

  const refetchAndSync = async (...args) => {
    const result = await refetch(...args)
    queryClient.invalidateQueries(["creditHistoryPerProduct"])
    return result
  }

  return{isPending,isSuccess,isError,isFetching,refetch: refetchAndSync,error,data}
}

export default useGetWalletData
